(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('fundraisingSidebar', fundraisingSidebar);

    /* @ngInject */
    function fundraisingSidebar() {
        var directive = {
            bindToController: true,
            templateUrl: 'fundraising-sidebar.tpl',
            controller: fundraisingSidebarController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                type: '@',
                editable: '=',
                shareName: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var twitterText = '';
            var hashtags = 'pies';
            // scope.vm.shareName
            if (scope.$root.globals.site_options.project_slug == 'ff') {
                twitterText = "Purchase your Thanksgiving pies through Food \u0026 Friends' Slice of Life. Proceeds provide nutritious, home-delivered meals to neighbors facing serious illnesses.";
                hashtags += ',sliceoflifedc';
            } else if (scope.$root.globals.site_options.project_slug == 'manna') {
                twitterText = "Proceeds provide nutritious, home-delivered meals to neighbors facing serious illnesses.";
                hashtags += ',manna';
            } else if (scope.$root.globals.site_options.project_slug == 'mk') {
                twitterText = "Each pie purchased provides 12 medically tailored meals to a critically ill San Diegan.";
                hashtags += ',mamaskitchen';
            }
            // if(scope.$root.project_has_opt("layoutFF")) {
            //     twitterText = "Purchase your Thanksgiving pies through Food \u0026 Friends' Slice of Life. Proceeds provide nutritious, home-delivered meals to neighbors facing serious illnesses.";
            //     hashtags += ',sliceoflifedc';
            // } else {
            //     twitterText = "Proceeds provide nutritious, home-delivered meals to neighbors facing serious illnesses.";
            //     hashtags += ',manna';
            // }
            twitterText = twitterText.replace(/\#/g, '%23');
            //twitterText = twitterText.replace(/\&/g, '%26');
            scope.vm.twitterLink = "https://twitter.com/share?text=" + escape(twitterText) + '&url=' + encodeURI(location.href) + '&hashtags=' + hashtags;
            scope.vm.facebookLink = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(location.href);
            scope.vm.total = scope.vm.data.hq.stats.total;
            scope.vm.price = scope.vm.data.hq.stats.pie_price;
            scope.vm.sold = scope.vm.data.hq.stats.sold;
            scope.vm.progress = Math.round(scope.vm.sold / scope.vm.data.hq.goal.value * 100);
            scope.vm.towards = 100 - scope.vm.progress;
            // scope.vm.days2go = scope.vm.data.hq.stats.days2go;
            scope.vm.days2go = scope.$root.globals.site_options.shopping_cart_settings.days2go;
            scope.checkCookies();
        }
    }

    /* @ngInject */
    function fundraisingSidebarController ($scope, $http, $rootScope, $cookies, $location, $route) {
        $scope.saving = false;
        $scope.save = function(e) {
            $scope.doSave('save_' + $scope.vm.type + '_data', {
                hq: {
                    goal: {
                        value: $scope.vm.data.hq.goal.value
                    }
                }
            });
        };

        $scope.doSave = function(method, data, callback) {
            if (!$scope.saving) {
                $scope.saving = true;
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: method,
                    nonce: $scope.$root.stats.nonce,
                    params: data
                }).then(function(response) {
                    $scope.saving = false;
                    if (typeof callback == 'function') {
                        callback(response.data);
                    }
                });
            }
        };
        $rootScope.selectedSeller = undefined;
        $rootScope.selectedSellerName = '';
        $scope.selectSeller = function() {
            if ($scope.vm.type == 'team') {
                $rootScope.selectedSeller = $scope.vm.data.ghost_id;
            } else {
                $rootScope.selectedSeller = $scope.vm.data.post_id;
            }
        };
        $scope.createJoinIntent = function() {
            var expiresValue = new Date();
            expiresValue.setTime(expiresValue.getTime() + 1000 * 3600);
            console.log(expiresValue);
            $cookies.put('joinIntent', $scope.vm.data.id, {
                expires : expiresValue,
                path: '/'
            });
        };
        $scope.joinTeam = function() {
            if(!$scope.$root.stats.current_user) {
                $scope.createJoinIntent();
                $scope.$root.openModal("login-form");
            } else if ($scope.$root.stats.current_user.memberOf.slug == $scope.vm.data.slug) {
                $scope.$root.errorMessage = 'You already a member of this team';
                $scope.$root.openModal("error-modal");
            } else if ('individual' == $scope.$root.stats.current_user.memberOf.slug) {
                $scope.createJoinIntent();
                $scope.doSave('join_a_team', {team_id: $scope.vm.data.id}, function(response) {
                    $cookies.put('joinMessage', response.message, {
                        path: '/'
                    });
                    $route.reload();
                });
            } else if ($scope.$root.stats.current_user.memberOf) {
                $scope.$root.errorMessage = 'You cannot join this team because you are a member of the team ' + $scope.$root.stats.current_user.memberOf.name ;
                $scope.$root.openModal("error-modal");
            } else {
                $location.url('/seller-sign-up/');
            }
        };
        $scope.checkCookies = function() {
            if ($cookies.get('joinIntent')) {
                $scope.joinTeam();
            }
            if ($cookies.get('joinMessage')) {
                $scope.$root.errorMessage = $cookies.get('joinMessage');
                $scope.$root.openModal("error-modal");
                $cookies.remove('joinMessage', {path: '/'});
            }

        };
    }

})();